import { useCallback } from 'react';

import { QRCode } from 'core/Components';
import {
  Box,
  Button,
  Card,
  Center,
  Container,
  Group,
  ImageMantine,
  MobileBottomButton,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from 'ui';

const MAGIC_LINK = 'https://api.givebacks.com/magic';
const APP_STORE_IMAGE =
  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/onboarding/app-store.png';
const GOOGLE_PLAY_IMAGE =
  'https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/onboarding/play-store.png';

const DownloadAppButton = () => {
  const handleDownloadApp = useCallback(() => {
    return window.open(MAGIC_LINK, '_blank');
  }, []);
  return <Button onClick={handleDownloadApp}>Download the App</Button>;
};

const StoreImages = () => {
  return (
    <Group gap={12}>
      <ImageMantine src={APP_STORE_IMAGE} h={24} />
      <ImageMantine src={GOOGLE_PLAY_IMAGE} h={24} w="auto" />
    </Group>
  );
};

const StudentFeesNonAuth = () => {
  return (
    <Center>
      {/* Add padding bottom to the container to avoid the bottom button from being cut off */}
      <Container size="md" h="100%" pb={{ base: 60, sm: 0 }}>
        <SimpleGrid cols={{ base: 1, sm: 2 }}>
          <Stack h="100%">
            <Title order={2} ta="start">
              School fees made easy!
            </Title>
            <Text fz={14}>
              From field trips to club fees, the Givebacks app makes school payments easy, fast, and
              stress-free.
            </Text>

            <Stack align="center">
              <Card withBorder visibleFrom="sm" w={150} h={150} p="md">
                <QRCode value={MAGIC_LINK} size={118} />
              </Card>

              <Text fz={14} fw={600} visibleFrom="sm">
                Scan the QR code to download now:
              </Text>

              <StoreImages />
            </Stack>
          </Stack>
          <Box mah={410}>
            <Center>
              <ImageMantine
                radius="md"
                src="https://s3.us-east-1.amazonaws.com/com.givebacks.public/images/onboarding/student-fees-preview.png"
                h="auto"
                w="auto"
                mah={410}
              />
            </Center>
          </Box>
        </SimpleGrid>
        <MobileBottomButton mobileBreakpoint="sm">
          <DownloadAppButton />
        </MobileBottomButton>
      </Container>
    </Center>
  );
};

export { StudentFeesNonAuth };
